import BaseCtrl from 'edge/platform/base/BaseCtrl';
import DateUtil from 'gw-portals-util-js/DateUtil';
import _ from 'underscore';

var fn = function fn($scope, AgeAllowedToDrive, submissionViewModel, DriverLicenseUtil) {

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.documents = [];
        $scope.metadataTemplate = {
            docUID: '001',
            documentType: 'letter_received',
            securityType: 'unrestricted',
            status: 'approved'
        };
        $scope.isDriverLicenseZipcodeMismatch = false;
        // This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
        var sanitisePrefillDataFromQuickQuote = function sanitisePrefillDataFromQuickQuote(accountHolder) {
            if (accountHolder.firstName === '0dummyname0') {
                accountHolder.firstName = undefined;
                accountHolder.lastName = undefined;
                accountHolder.dateOfBirth = undefined;
            }
            if (accountHolder.emailAddress1 === 'dummy@email.dummy') {
                accountHolder.emailAddress1 = undefined;
            }
        };

        $scope.submissionVm = submissionViewModel();

        $scope.postalCodeReadonly = angular.isDefined($scope.submissionVm.baseData.policyAddress.postalCode.value);
        $scope.stateReadonly = angular.isDefined($scope.submissionVm.baseData.policyAddress.state.value);

        $scope.accountHolder = $scope.submissionVm.baseData.accountHolder.value;
        $scope.entryDate = $scope.submissionVm.baseData.periodStartDate.value;
        sanitisePrefillDataFromQuickQuote($scope.accountHolder);

        $scope.accountHolder.primaryPhoneType = null;
        $scope.submissionVm.baseData.policyAddress.addressType.value = $scope.submissionVm.baseData.policyAddress.addressType.value || 'home';

        $scope.today = DateUtil.currentDateAtMidnight();

        $scope.maxDateOfBirth = {
            year: $scope.today.getFullYear() - AgeAllowedToDrive,
            month: $scope.today.getMonth(),
            day: $scope.today.getDate()
        };
    };

    $scope.$watchCollection('documents', function (driverLicenses) {
        var accountHolder = $scope.submissionVm.baseData.accountHolder;
        if (driverLicenses.length >= 1) {
            var driverLicenseData = driverLicenses.pop();
            DriverLicenseUtil.setLicenseUploadProperties(accountHolder, driverLicenseData);
            if (!accountHolder.errorUploading) {
                var postalCode = $scope.submissionVm.baseData.policyAddress.postalCode.value;
                $scope.isDriverLicenseZipcodeMismatch = driverLicenseData.primaryAddress.postalCode !== postalCode;
                DriverLicenseUtil.fillContactInfo(accountHolder, driverLicenseData, $scope.isDriverLicenseZipcodeMismatch);
                if (!$scope.isDriverLicenseZipcodeMismatch) {
                    $scope.submissionVm.baseData.policyAddress.value = driverLicenseData.primaryAddress;
                }
            }
        }
    });

    $scope.$watch('submissionVm.baseData.accountHolder.dateOfBirth.value', function () {
        // When coming from a Streamlined Quote, ensure the driver DOB is in sync with the Account Holder.
        // Also ensures that any change to the account holder driver DOB is synced with the appropriate driver.
        if (angular.isDefined($scope.submissionVm.lobData.personalAuto.coverables)) {
            var drivers = $scope.submissionVm.lobData.personalAuto.coverables.drivers;
            if (drivers && drivers.length > 0) {
                var paDriver = _.findWhere(drivers.value, { isPolicyHolder: true });
                if (angular.isDefined(paDriver)) {
                    paDriver.dateOfBirth = angular.copy($scope.submissionVm.baseData.accountHolder.dateOfBirth.value);
                }
            }
        }
    });

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'AgeAllowedToDrive', 'submissionViewModel', 'DriverLicenseUtil'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/controllers/PAContactDetailsCtrl.js
// module id = 2164
// module chunks = 0